import UnderlinedText from "./underlined_text";
import { Grid, Typography, Checkbox } from "@mui/material";
import { fieldHeader } from "../../../../components/fields/field_header";

const ViewShopperEngagement = ({ data }: any) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          SHOPPER ENGAGEMENT:
          <Typography variant="body2">
            <Typography variant="body2">
              Please check the programs that you currently have in your store:
            </Typography>
          </Typography>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Checkbox checked={data.websiteDeveloper} /> Website Developer?
      </Grid>
      {data.websiteDeveloper && (
        <Grid item xs={12}>
          <Grid item>{fieldHeader("Website Developer Company", false)}</Grid>
          <UnderlinedText text={data.websiteDeveloperCompany} />
        </Grid>
      )}
      <Grid item xs={12}>
        <Checkbox checked={data.ecommerceStorePickup} /> Ecommerce Store Pickup
      </Grid>
      {data.ecommerceStorePickup && (
        <Grid item xs={12}>
          <Grid item>
            {fieldHeader("Ecommerce Store Pickup Company", false)}
          </Grid>
          <UnderlinedText text={data.ecommerceStorePickupCompany} />
        </Grid>
      )}
      <Grid item xs={12}>
        <Checkbox checked={data.ecommerceDelivery} /> Ecommerce Delivery
      </Grid>
      {data.ecommerceDelivery && (
        <Grid item xs={12}>
          <Grid item>{fieldHeader("Ecommerce Delivery Company", false)}</Grid>
          <UnderlinedText text={data.ecommerceDeliveryCompany} />
        </Grid>
      )}
      <Grid item xs={12}>
        <Checkbox checked={data.loyaltyProgram} /> Loyalty Program
      </Grid>
      {data.loyaltyProgram && (
        <Grid item xs={12}>
          <Grid item>{fieldHeader("Loyalty Program Company", false)}</Grid>
          <UnderlinedText text={data.ecommerceStorePickupCompany} />
        </Grid>
      )}
      <Grid item xs={12}>
        <Checkbox checked={data.socialMedia} /> Social Media
      </Grid>
      {data.socialMedia && (
        <Grid item xs={12}>
          <Grid item>{fieldHeader("Social Media Managed by", false)}</Grid>
          <UnderlinedText text={data.socialMediaManager} />
        </Grid>
      )}
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Coca-Cola Bottler", false)}</Grid>
        <UnderlinedText text={data.cocaColaBottler} />
      </Grid>
    </>
  );
};

export default ViewShopperEngagement;
